










helpers = require('../../helpers.coffee')

view_model =
  props:
    filters:
      default: () -> {}

  data: ->
    period_filter: {}
    manual_task_service_filter: @extractFilter('manual_task_service_eq')
    manual_task_service_options: [
      { value: null, text: 'Todos os eventos' }
      { value: { manual_task_service_eq: 'ManualTasksServices::Email' }, text: 'Email' }
      { value: { manual_task_service_eq: 'ManualTasksServices::Phonecall' }, text: 'Ligação' }
      { value: { manual_task_service_eq: 'ManualTasksServices::Linkedin' }, text: 'Linkedin/Social' }
    ]

  computed:
    filterParams: ->
      filter_params = {}
      for filter in [@manual_task_service_filter, @period_filter]
        Object.assign(filter_params, filter) if filter
      filter_params

  methods:
    filter: ->
      @$emit('filter', @filterParams)

    dateChanged: (data) ->
      @updateDateFilter('created_at_gteq', data.from)
      @updateDateFilter('created_at_lteq', data.to)
      @filter()

    updateDateFilter: (key, value) ->
      if value
        Vue.set @period_filter, key, JSON.stringify(value)
      else
        Vue.delete @period_filter, key




exports.default = helpers.vue_include(view_model, helpers.filters)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/events/filters.vue